Apt.fn.extend('maps', {
	/**
	 * Replace markers
	 *
	 * @param {Array} points
	 */
	setMarkers(points) {
		const priv = this.$private;

		priv.layers.listings = [];

		priv.map.getSource('points')
			.setData(priv.empty);

		priv.addMarkers(points, () => {
			priv.fitBounds(points);
		});
	}
}, {
	/**
	 * Register event handlers for pin actions
	 */
	initMarkers() {
		const scope = this;

		scope.addMarkerLayers();

		if (
			scope.conf.basic ||
			scope.conf.single
		) {
			return;
		}

		LS.util.idle([
			scope.bindMarkerHover,
			scope.bindMarkerClick
		], scope);
	},

	/**
	 * Display individual markers
	 */
	addMarkerLayers() {
		const scope = this;
		const single = scope.conf.single;

		scope.addLayer({
			id: 'markers',
			type: 'circle',
			source: 'points',
			minzoom: scope.conf.showPoints ?
				0 : scope.break,
			filter: ['!has', 'point_count'],
			paint: {
				'circle-color': single ?
					'#c77474' : scope.getColors(),
				'circle-opacity': scope.conf.single ? 1 : [
					'case',
					['boolean', ['feature-state', 'highlight'], false], 0,
					['==', ['to-string', ['get', 'c']], 'pending'], 0.6,
					1
				],
				'circle-radius': 5,
				'circle-stroke-color': '#f2f9f5',
				'circle-stroke-opacity': single ? 0.7 : [
					'case',
					['boolean', ['feature-state', 'highlight'], false], 0,
					['==', ['to-string', ['get', 'c']], 'pending'], 0.3,
					0.5
				],
				'circle-stroke-width': single ? 6 : [
					'case',
					['<=', ['to-number', ['get', 's']], 3], 1.4,
					['log2', ['to-number', ['get', 's']]]
				],
			}
		});

		if (single) {
			return;
		}

		scope.working = true;

		const desktop = $.screen.size() > 3;

		scope.addMarkerImage(() => {
			scope.addLayer({
				id: 'labels',
				type: 'symbol',
				source: 'points',
				minzoom: scope.conf.showPoints ?
					0 : scope.break,
				filter: [
					'all',
					['!has', 'point_count']
				],
				layout: {
					'icon-allow-overlap': true,
					'icon-ignore-placement': true,
					'icon-image': 'mark',
					'icon-text-fit': 'both',
					'text-field': '{p_short}{suffix}',
					'text-font': [
						'averta-semi'
					],
					'text-letter-spacing': -.012,
					'text-line-height': 1,
					'text-padding': 10,
					'text-offset': [0, -0.9],
					'text-size': 15
				},
				paint: {
					'icon-opacity': desktop ? [
						'case',
						['boolean', ['feature-state', 'open'], false], 0,
						1
					] : 1,
					'text-color': scope.getColors(),
					'text-opacity': desktop ? [
						'case',
						['boolean', ['feature-state', 'open'], false], 0,
						1
					] : 1
				}
			});

			scope.addHighlight();

			scope.working = false;
		});
	},

	/**
	 * Get marker colors
	 *
	 * @returns {Array}
	 */
	getColors() {
		return [
			'case',
			['boolean', ['feature-state', 'open'], false], '#c77474',
			['boolean', ['feature-state', 'highlight'], false], '#c77474',
			['boolean', ['feature-state', 'hover'], false], '#050b08',
			['==', ['to-string', ['get', 'c']], 'pending'], '#75732e',
			['==', ['to-string', ['get', 'f']], 'auction'], '#633380',
			['==', ['to-string', ['get', 'f']], 'lease'], '#336e80',
			'#22563c'
		];
	},

	/**
	 * Add additional points to map
	 *
	 * @param {Array} [markers]
	 * @param {Function} [fn]
	 */
	addMarkers(markers, fn) {
		const scope = this;
		const pub = scope.$public;
		const points = markers || scope.layers.listings;

		scope.working = true;

		if (points && points.length) {
			points.forEach(point => {
				const format = point.properties.f;

				let suffix = '';

				if (format === 'lease') {
					if (point.properties.t) {
						suffix = '/' + point.properties.t;
					}
				} else if (format === 'auction') {
					suffix = ' min';
				}

				point.properties.id = point.id;
				point.properties.suffix = suffix;
				point.properties.c = point.properties.c || 'active';

				point.properties.p_short = // eslint-disable-line
					point.properties.p ?
						'$' + LS.util.shortFormat(point.properties.p) : '$—';

				point.properties.s_short = // eslint-disable-line
					point.properties.s ?
						LS.util.shortFormat(point.properties.s, 1) + ' ac' : '— ac';
			});
		}

		if (markers) {
			scope.layers.listings = [
				...scope.layers.listings,
				...points
			];
		}

		const onData = e => {
			if (! e.isSourceLoaded) {
				return;
			}

			scope.working = false;

			pub.unbind('map', 'sourcedata', onData);

			if (fn) {
				requestAnimationFrame(() => {
					fn();
				});
			}
		};

		pub.bind('map', 'sourcedata', onData);

		try {
			scope.map.getSource('points')
				.setData({
					type: 'FeatureCollection',
					features: scope.layers.listings
				});
		} catch (e) {
			//
		}
	},

	/**
	 * Add marker image
	 *
	 * @param {Function} fn
	 */
	addMarkerImage(fn) {
		const map = this.map;

		map.loadImage('/assets/modules/maps@' + $.get('versions.maps') + '/img/mark.png')
			.then(image => {
				if (image && map && ! map.hasImage('mark')) {
					map.addImage('mark', image.data, {
						stretchX: [
							[28, 45],
							[59, 76]
						],
						content: [14, 13, 89, 44],
						pixelRatio: 2
					});
				}

				fn();
			});
	},

	/**
	 * Bind pin hover events
	 */
	bindMarkerHover() {
		const scope = this;
		const pub = scope.$public;

		[
			'highlight',
			'labels',
			'markers'
		].forEach(layer => {
			pub.bind(layer, 'mousemove', e => {
				const feature = e.features[0];

				if (scope.hoverMarker && scope.hoverMarker.id === feature.id) {
					return;
				}

				scope.deactivate();

				if (scope.hoverMarker) {
					scope.map.setFeatureState(scope.hoverMarker, {
						hover: false
					});
				}

				scope.hoverMarker = feature;

				scope.map.setFeatureState(scope.hoverMarker, {
					hover: true
				});

				if (e.features.length > 1 && scope.conf.onClusterEnter) {
					const features = scope.getUnique(e.features);

					if (features.length > 1) {
						scope.conf.onClusterEnter(pub, e.features);

						return;
					}
				}

				scope.model.$set('listing', feature.properties);
			});

			pub.bind(layer, 'mouseleave', () => {
				if (! scope.hoverMarker) {
					return;
				}

				scope.map.setFeatureState(scope.hoverMarker, {
					hover: false
				});

				scope.hoverMarker = null;

				scope.model.$drop('listing');
				scope.model.$drop('message');
			});
		});
	},

	/**
	 * Bind pin click events
	 */
	bindMarkerClick() {
		const scope = this;
		const pub = scope.$public;

		pub.bind('map', 'click', e => {
			const features = pub.getFeatures({
				layers: [
					'highlight',
					'labels',
					'markers'
				]
			}, e.point);

			if (! features.length) {
				pub.hideTooltip();

				return;
			}

			if (scope.model) {
				scope.model.$drop('listing');
			}

			if (features.length > 1) {
				const zoom = scope.map.getZoom();

				if (zoom < 14.5) {
					pub.center(features[0].geometry.coordinates, {
						animate: true,
						zoom: Math.max(zoom + ((18.4 - zoom) * 0.25), zoom)
					});

					return;
				}
			}

			if (scope.conf.onClick) {
				scope.conf.onClick(pub, features);
			}
		});
	}
});